<template>
  <div
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_DocumentEntry')" name="seDocInput" style="width:100%;height: 100%">
          <se-input-detail
            tab-name="seDocInput"
            :tab-title="$t('CargoMsg.Cargo_DocumentEntry')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_QueryTags')" name="searchMark" style="width:100%;height: 100%">
          <search-mark-detail
            tab-name="searchMark"
            :tab-title="$t('CargoMsg.Cargo_QueryTags')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ChargebackManage')" name="managementOfWithdrawal" style="width:100%;height: 100%">
          <management-of-withdrawal-detail
            tab-name="managementOfWithdrawal"
            :tab-title="$t('CargoMsg.Cargo_ChargebackManage')"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import batchUploadFileChild from '@/components/Cargo/Job/uploadFile/batchUploadFileChild'
import seInputDetail from '@/views/cargo/v0/Clearing/components/DocumentCirculation/seDocInputDetail'
import searchMarkDetail from '@/views/cargo/v0/Clearing/components/DocumentCirculation/searchMarkDetail'
import managementOfWithdrawalDetail from '@/views/cargo/v0/Clearing/components/DocumentCirculation/managementOfWithdrawalDetail'

export default {
  name: 'DocumentCirculation',
  components: { batchUploadFileChild, seInputDetail, searchMarkDetail, managementOfWithdrawalDetail },
  data() {
    return {
      loading: true,
      activeTabName: 'seDocInput'
    }
  },
  async created() {
    this.loading = false
  }
}
</script>
